import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';
import propertyObjectFactory from '../../../../utils/propertyObjectFactory';

export default function propertyObjectsReducer(state = initialState, action) {
  switch (action.type) {
    case action.type === actionTypes.REQUEST_START ||
      action.type === actionTypes.FILTERED_REQUEST_START:
      return Map({
        loading: true,
        data: null,
        error: null,
      });
    case actionTypes.REQUEST_SUCCESS:
      return Map({
        loading: false,
        data: mapPropertyObjects(action.payload),
        error: null,
      });
    case actionTypes.REQUEST_FAILURE:
      return Map({
        loading: false,
        data: null,
        error: action.payload,
      });
    case actionTypes.UPDATE_TITLE:
      return state.setIn(['data', `${action.payload.id}`], getUpdatedObject(state, action.payload));
    case actionTypes.CLEAR_CHANGES:
      return state.setIn(['data', `${action.payload}`], getClearedObject(state, action.payload));
    default:
      return state;
  }
}

function mapPropertyObjects(propertyObjects) {
  const propertyObjectsMap = {};

  propertyObjects.forEach(function (propertyObjectConfig) {
    const object = propertyObjectFactory(propertyObjectConfig);
    propertyObjectsMap[object.id] = object;
  });

  return Map(propertyObjectsMap);
}

function getUpdatedObject(state, payload) {
  const object = state.getIn(['data', `${payload.id}`]);
  object.title = payload.title;

  return object;
}

function getClearedObject(state, payload) {
  const object = state.getIn(['data', `${payload}`]);
  object.changeToAccept = null;

  return object;
}
